import { forwardRef } from 'react';
import { DateInput } from '@/components/ui/Input.jsx';

export const DatePicker = forwardRef(function DatePicker(props, ref) {
  return <DateInput ref={ref} {...props} />;
});
